import {GooglePlacesTypes} from '@/modules/googleAutocomplete/enums/GooglePlacesTypes';

type GooglePredictionInput = {
  description: string;
  place_id: string;
  types: string[];
};

export default class GoogleAutocompletePrediction {
  public description!: string;
  public matched_substrings?: google.maps.places.PredictionSubstring[];
  public place_id!: string;
  public reference?: string;
  public structured_formatting?: google.maps.places.AutocompleteStructuredFormatting;
  public terms?: google.maps.places.PredictionTerm[];
  types!: GooglePlacesTypes[];
  id?: string;

  get icon(): string {
    return this.types.includes(GooglePlacesTypes.LOCALITY)
      ? 'mdi-city'
      : 'mdi-road-variant';
  };

  constructor(autocompletePrediction: GooglePredictionInput) {
    Object.assign(this, autocompletePrediction);
  }

  static fromPlacePrediction(prediction: google.maps.places.PlacePrediction): GoogleAutocompletePrediction {
    return new GoogleAutocompletePrediction({
      description: prediction.text?.text || '',
      place_id: prediction.placeId,
      types: prediction.types || [],
    });
  }
}
